import React, { useEffect } from 'react';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import useCustomNavigate from '../hooks/useCustomNavigate';

const AppUrlListener: React.FC = () => {
    const navigate = useCustomNavigate();

    useEffect(() => {
        const handler = App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
            const url = new URL(event.url);

            const path = url.pathname;
            const search = url.search;

            // Pass full path including query params to your navigate function
            navigate(path + search);
        });

        // Clean up listener on unmount
        return () => {
            handler.then(handle => handle.remove());
        };
    }, [navigate]);

    return null;
};

export default AppUrlListener;
